import { capitalizeFirstLetter } from './string';

const getVeterinarioNombreCompleto = (vet?: {
  nombre?: string | null;
  apellido?: string | null;
}): string =>
  vet?.nombre
    ? `${capitalizeFirstLetter(vet.nombre)}${
        vet.apellido ? ` ${capitalizeFirstLetter(vet.apellido)}` : ''
      }`
    : '';

export { getVeterinarioNombreCompleto };
